"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M8.91 2.44A9.87 9.87 0 0 1 21.241 12a.891.891 0 0 1-1.78 0 8.091 8.091 0 0 0-16.137-.836 8.092 8.092 0 0 0 1.829 6.011 7.62 7.62 0 0 1 8.963-4.334 1.113 1.113 0 1 1-.576 2.15 5.39 5.39 0 0 0-6.593 3.781A8.09 8.09 0 0 0 12.568 20a.89.89 0 0 1 .264 1.762A9.872 9.872 0 0 1 8.909 2.441Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M18.199 13.201A4.3 4.3 0 0 1 22.5 17.5a4.3 4.3 0 0 1-4.301 4.297 4.3 4.3 0 0 1-4.303-4.297 4.3 4.3 0 0 1 4.304-4.3Zm.01 1.168a.768.768 0 0 0-.768.768v1.536h-1.535a.768.768 0 0 0 0 1.536h1.535v1.535a.768.768 0 0 0 1.536 0v-1.535h1.535a.769.769 0 0 0 0-1.536h-1.535v-1.536a.769.769 0 0 0-.768-.768Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M13.984 8.55a2.612 2.612 0 1 1-5.225 0 2.612 2.612 0 0 1 5.225 0Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};